import React from 'react';
import { Checkbox, LinearProgress, Typography } from '@dls/react-core';
import { List, ListItem, ListItemIcon } from '@material-ui/core';
import { Checkmark16 } from '@dls/react-icons';
import { MeasurementType } from '../../../api/studykit';

interface MeasurementListProps {
  onSelection: (selected: boolean, type: MeasurementType) => void;
  selected: MeasurementType[];
  options: MeasurementType[];
}

export const MeasurementList: React.FC<MeasurementListProps> = ({
  onSelection,
  selected,
  options,
}) => {
  if (options.length === 0) return <LinearProgress />;
  return (
    <List style={{ overflow: 'hidden', padding: 0 }} disablePadding>
      {options.map((type) => {
        const isSelected = selected.some((t) => t.name === type.name);
        return (
          <ListItem
            key={type.name}
            style={{ backgroundColor: 'unset' }}
            button
            disableRipple
            disableTouchRipple
            disableGutters
            selected={isSelected}
            onClick={() => onSelection(!isSelected, type)}
          >
            <ListItemIcon style={{ minWidth: 'unset' }}>
              <Checkbox checked={isSelected} checkedIcon={<Checkmark16 />} />
            </ListItemIcon>

            <Typography>{type.label} </Typography>
          </ListItem>
        );
      })}
    </List>
  );
};
